import baseScmService from 'services/baseScmService';

const superBatchModuleService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchSuperBatchModule: build.query({
      query: ({ category, keyword }) => ({
        method: 'GET',
        url: '/academy-modules/search/',
        params: { 'filter[category]': category?.value, q: keyword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchSuperBatchModuleQuery } = superBatchModuleService;

export default superBatchModuleService;
